angular.module('stack.common.i18n.models.TranslationModel', [
  'angular-cache',
  'global'
])

/**
 * The TranslationModel houses localization strings.
 *
 * @class TranslationModel
 * @constructor
 * @module stack.common.i18n.models.TranslationModel
 */
.factory('TranslationModel', [
  '$http',
  '$locale',
  '$log',
  '$angularCacheFactory',
  'GLOBAL',
  function ($http, $locale, $log, $angularCacheFactory, GLOBAL) {
    'use strict';

    // Define.
    var service = {
      /**
       * Property houses model cache.
       *
       * @property cache
       * @type {Object}
       */
      cache: $angularCacheFactory('i18n', {
        storageMode: 'localStorage'
      }),

      /**
       * Method returns locale string.
       *
       * @return {string} Locale string
       */
      getLocale: function getLocale() {
        return $locale.id;
      },

      /**
       * Method requests object containing localized strings.
       * This method requests data from the server.
       *
       * @return {Promise<Object>|Promise<Array>} collection of localized strings
       */
      getMap: function getMap() {
        return $http({
          cache: true,
          method: 'GET',
          url: GLOBAL.base + '/' + GLOBAL.localizationPath + $locale.id + '.json',
          data: { cb: new Date().getTime() }
        });
      },

      /**
       * Method requests object containing localized strings from the
       * model cache. When the cache is empty, this method requests
       * localized strings from the server.
       *
       * @return {Promise<Object>|Promise<Array>} collection of localized strings
       */
      get: function get() {
        var map = service.cache.get('map');

        if (angular.isDefined(map) && angular.isObject(map) && !_.isEmpty(map)) {
          return map;
        }
        return service
          .getMap()
          .then(function (response) {
            var result = response.data;
            service.cache.put('map', result);
            return service.cache.get('map');
          })
          .catch(function () {
            $log.warn('Localization data for ' + service.getLocale() + ' could not be loaded.');
            service.cache.removeAll();
            service.cache.put('map', {});
            return service.cache.get('map');
          });
      },

      /**
       * Method returns the translation cache.
       *
       * @return {Object} Translation cache.
       */
      getCache: function getCache() {
        return service.cache.get('map') || {};
      },

      /**
       * Method removes all values from the cache.
       */
      removeAll: function removeAll() {
        service.cache.removeAll();
        service.cache.put('map', {});
      },

      /**
       * Method initializes model.
       */
      initialize: function initialize() {
        service.cache.put('map', {});
      }
    };

    service.initialize();
    return service;
  }
]);
